module.exports = __webpack_public_path__ + "static/img/phone_afsc_icon2.f2bfa2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone_afsc_icon2.png
// module id = YCpo
// module chunks = 1